// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { CustomThemeProvider } from "./ThemeContext"; // Импортируем CustomThemeProvider
import App from "./App";
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <CustomThemeProvider> {/* Используем CustomThemeProvider */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </CustomThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
